import { inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProcessingButtonComponent } from './processing-button/processing-button';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatStepperModule } from '@angular/material/stepper';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CopyTextButtonComponent } from './copy-text-button/copy-text-button.component';
import { SafeResourceUrlPipe } from './pipes/safe-url.pipe';
import { RichEditorComponent } from './rich-editor/rich-editor.component';
import { PageComponent } from './page/page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  UIKitModule,
  VaActionMenuComponent,
  VaFilterModule,
  VaProductNavService,
} from '@vendasta/uikit';
import { EmailSettingsComponent } from '../settings/email-workflow/email-settings.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { PreviewTemplateComponent } from '../customers/send-review-request/preview-template/preview-template.component';
import { SelectTemplateComponent } from '../customers/send-review-request/select-template/select-template.component';
import { SendReviewRequestComponent } from '../customers/send-review-request/send-review-request.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TranslateModule } from '@ngx-translate/core';
import { FloatingSendReviewRequestButtonComponent } from '../navigable-app/floating-send-review-request-button/floating-send-review-request-button.component';
import { ReviewUrlComponent } from './review-url/review-url.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { GalaxyUploaderModule } from '@vendasta/galaxy/uploader';
import { ImageUploaderEditorComponent } from './image-uploader-editor/image-uploader-editor.component';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { GALAXY_PAGE_OPTIONS, GalaxyPageModule, GalaxyPageOptions } from '@vendasta/galaxy/page';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyEmailViewerModule } from '@vendasta/galaxy/email-viewer';
import { PreviewSendEmailComponent } from '../preview-send-email/preview-send-email.component';

@NgModule({
  declarations: [
    ReviewUrlComponent,
    FloatingSendReviewRequestButtonComponent,
    ProcessingButtonComponent,
    CopyTextButtonComponent,
    SafeResourceUrlPipe,
    RichEditorComponent,
    PageComponent,
    EmailSettingsComponent,
    SendReviewRequestComponent,
    PreviewTemplateComponent,
    SelectTemplateComponent,
    ImageUploaderEditorComponent,
    PreviewSendEmailComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    TranslateModule.forChild({
      extend: true,
    }),
    MatToolbarModule,
    MatSidenavModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatListModule,
    MatTableModule,
    MatCheckboxModule,
    MatSelectModule,
    MatCardModule,
    MatStepperModule,
    MatChipsModule,
    MatInputModule,
    MatSnackBarModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatRadioModule,
    MatExpansionModule,
    MatTooltipModule,
    MatDialogModule,
    MatRippleModule,
    MatProgressBarModule,

    ReactiveFormsModule,
    VaFilterModule,
    FormsModule,
    GalaxyUploaderModule,
    VaActionMenuComponent,
    ColorPickerModule,
    UIKitModule,
    ClipboardModule,
    GalaxyPipesModule,
    GalaxyPageModule,
    GalaxyBadgeModule,
    GalaxyAlertModule,
    GalaxyEmailViewerModule,
  ],
  exports: [
    FloatingSendReviewRequestButtonComponent,
    ProcessingButtonComponent,
    CopyTextButtonComponent,
    SafeResourceUrlPipe,
    RichEditorComponent,
    PageComponent,
    EmailSettingsComponent,
    PreviewTemplateComponent,
    SendReviewRequestComponent,
    SelectTemplateComponent,
    ReviewUrlComponent,
    ImageUploaderEditorComponent,
    PreviewSendEmailComponent,

    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,

    DragDropModule,
    MatToolbarModule,
    MatSidenavModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatListModule,
    MatTableModule,
    MatCheckboxModule,
    MatSelectModule,
    MatCardModule,
    MatStepperModule,
    MatChipsModule,
    MatInputModule,
    MatSnackBarModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatRadioModule,
    MatExpansionModule,
    MatTooltipModule,
    MatDialogModule,
    MatRippleModule,
    MatProgressBarModule,

    ReactiveFormsModule,
    VaFilterModule,
    FormsModule,
    VaActionMenuComponent,
    ColorPickerModule,
    TranslateModule,
  ],
  providers: [
    {
      provide: GALAXY_PAGE_OPTIONS,
      useFactory: galaxyNavOptionsFactory,
      deps: [VaProductNavService],
    },
    VaProductNavService,
  ],
})
export class SharedModule {}

export function galaxyNavOptionsFactory(): GalaxyPageOptions {
  const navControlService = inject(VaProductNavService);
  return {
    showToggle: true,
    toggleNav: () => navControlService.toggleNav(),
  };
}
